import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AdditionalDetails = ({ 
  purchaseDate, 
  onPurchaseDateChange,
  category,
  onCategoryChange,
  hashtag,
  onHashtagChange,
  errors 
}) => {
  const categoryOptions = [
    { value: 'fashion', label: 'Fashion & Apparel' },
    { value: 'beauty', label: 'Beauty & Cosmetics' },
    { value: 'electronics', label: 'Electronics & Tech' },
    { value: 'food', label: 'Food & Beverage' },
    { value: 'fitness', label: 'Fitness & Wellness' },
    { value: 'home', label: 'Home & Living' },
    { value: 'travel', label: 'Travel & Experiences' },
    { value: 'entertainment', label: 'Entertainment' },
    { value: 'other', label: 'Other' }
  ];

  return (
    <div className="space-y-4">
      <Input
        label="Purchase Date"
        type="date"
        value={purchaseDate}
        onChange={(e) => onPurchaseDateChange(e?.target?.value)}
        error={errors?.purchaseDate}
        required
        description="Date shown on your receipt"
        max={new Date()?.toISOString()?.split('T')?.[0]}
      />
      <Select
        label="Product Category"
        placeholder="Select category..."
        options={categoryOptions}
        value={category}
        onChange={onCategoryChange}
        error={errors?.category}
        required
        description="Choose the category that best matches your purchase"
      />
      <Input
        label="Campaign Hashtag (Optional)"
        type="text"
        placeholder="#BrandCampaign2026"
        value={hashtag}
        onChange={(e) => onHashtagChange(e?.target?.value)}
        description="Include if required by the brand campaign"
      />
    </div>
  );
};

export default AdditionalDetails;